/* ==========================================================================
   Reviews Carousel — vitrine em loop contínuo (scroll infinito)
   - Rolagem automática e contínua, em loop infinito (sem saltos)
   - Velocidade configurável (data-speed: 1 a 10)
   - Pause on hover (desktop) — opcional
   - Drag-to-scroll do usuário (mouse/caneta) + swipe nativo (touch)
   - Respeita prefers-reduced-motion (desliga o auto-scroll)
   - Suporta múltiplas instâncias
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function initCarousel(root) {
    if (root.dataset.rcInit === 'true') return;
    root.dataset.rcInit = 'true';

    var viewport = root.querySelector('[data-rc-viewport]');
    if (!viewport) return;

    var speed = parseInt(root.dataset.speed, 10);
    if (isNaN(speed)) speed = 5;
    var pxPerSec = speed * 18; // velocidade base por nível
    var pauseOnHover = root.dataset.pauseOnHover === 'true';

    var paused = false;     // hover / aba oculta
    var dragging = false;   // arrasto ou toque ativo

    function half() {
      return viewport.scrollWidth / 2;
    }

    function wrap() {
      var h = half();
      if (h <= 0) return;
      if (viewport.scrollLeft >= h) {
        viewport.scrollLeft -= h;
      } else if (viewport.scrollLeft <= 0) {
        viewport.scrollLeft += h;
      }
    }

    /* ----- Loop de animação (auto-scroll) ---------------------------------- */
    var lastTime = null;

    function tick(now) {
      if (lastTime == null) lastTime = now;
      var dt = (now - lastTime) / 1000;
      lastTime = now;

      if (!paused && !dragging) {
        viewport.scrollLeft += pxPerSec * dt;
        wrap();
      }
      window.requestAnimationFrame(tick);
    }

    /* ----- Pause on hover (desktop) --------------------------------------- */
    if (pauseOnHover) {
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
    }

    document.addEventListener('visibilitychange', function () {
      paused = document.hidden;
      if (!document.hidden) lastTime = null;
    });

    /* ----- Drag to scroll (mouse / caneta) -------------------------------- */
    var startX = 0;
    var startScroll = 0;
    var isDown = false;
    var moved = false;

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // touch usa scroll nativo
      isDown = true;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startScroll = viewport.scrollLeft;
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) {
        moved = true;
        viewport.classList.add('is-dragging');
        if (viewport.setPointerCapture && e.pointerId != null) {
          try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      if (moved) {
        viewport.scrollLeft = startScroll - dx;
        wrap();
      }
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      dragging = false;
      viewport.classList.remove('is-dragging');
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    /* Evita navegação acidental após arrastar sobre um link interno */
    viewport.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    /* ----- Touch: pausa auto-scroll e mantém wrap ------------------------- */
    viewport.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
    viewport.addEventListener('touchend', function () { dragging = false; }, { passive: true });
    viewport.addEventListener('scroll', function () {
      // mantém o loop infinito também durante o swipe nativo
      if (dragging) wrap();
    }, { passive: true });

    /* ----- Início ---------------------------------------------------------- */
    if (!reduceMotion) {
      window.requestAnimationFrame(tick);
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-rc-root]');
    roots.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();